// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import {
  AllowStatePage,
  CompletePage,
  ExtensionStatePage,
  HomePage,
  BrowserNotSupported,
} from './pages';
import { ROUTES } from './const';

export const routes = (
  <Routes>
    <Route path={ROUTES.home} element={<HomePage />}>
      <Route path={ROUTES.step1} element={<ExtensionStatePage />} />
      <Route path={ROUTES.step2} element={<AllowStatePage />} />
      <Route path={ROUTES.step3} element={<CompletePage />} />
      <Route path={ROUTES.notSupported} element={<BrowserNotSupported />} />
    </Route>
  </Routes>
);
